import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id ED39F995-49AB-4F63-9EEB-A5CAE8FDBE7F
 * name triangle-down-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-down-outline.svg
 * tags
 * - Shape 
 */
export const TriangleDownOutlineIcon = createSvgIcon(<><path d="M12 22L1 3H23M12 18L19.53 5H4.47" /></>, 'TriangleDownOutlineIcon');
export default TriangleDownOutlineIcon